import * as React from "react"
import Svg, { Defs, G, Circle, Path } from "react-native-svg"
/* SVGR has dropped some elements not supported by react-native-svg: style */
export default function RechazadoIcon(props) {
    return(
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Capa 2"
            viewBox="0 0 194.35 194.35"
            {...props}
        >
            <G data-name="Capa 1">
            <Circle
                cx={97.17}
                cy={97.17}
                r={97.17}
                style={{
                fill: "#ff1b51",
                }}
            />
            <Path
                d="m113.41 97.17 27.14-27.14c4.58-4.58 4.58-12.02 0-16.6-4.58-4.58-12.02-4.58-16.6 0L96.81 80.57 69.67 53.43c-4.58-4.58-12.02-4.58-16.6 0-4.58 4.58-4.58 12.02 0 16.6l27.14 27.14-27.14 27.14c-4.58 4.58-4.58 12.02 0 16.6 4.58 4.58 12.02 4.58 16.6 0l27.14-27.14 27.14 27.14c4.58 4.58 12.02 4.58 16.6 0 4.58-4.58 4.58-12.02 0-16.6l-27.14-27.14Z"
                style={{
                fill: "#fff",
                }}
            />
            </G>
        </Svg>
    )   
}